module.exports = __webpack_public_path__ + "static/media/rocket_flames.98356c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameProgramRobot/rocket_flames.png
// module id = 2450
// module chunks = 0